import React from "react";
import {getAuth, GoogleAuthProvider, signInWithPopup, signOut} from "firebase/auth";
import { auth } from "../../firebaseConfig";
import { useNavigate } from 'react-router-dom';
import {BsGoogle} from "react-icons/bs";

const SignIn = () => {
    const provider = new GoogleAuthProvider();

    const handleGoogleSignIn = async () => {
        try {
          // First, check that the user has a Middlebury email
          const result = await signInWithPopup(auth, provider);
          const userEmail = result.user.email;

          if (!userEmail.endsWith('@middlebury.edu')) {
            // Sign out immediately if not a Middlebury email
            await signOut(auth);
            alert("Only @middlebury.edu email addresses are allowed.");
            return;
          }

        } catch (error) {
          console.error("Google Sign-In error:", error);
          // Handle errors from the popup here
          if (error.code === 'auth/popup-closed-by-user') {
            console.log("Popup closed by user");
          }
        }
    };

    return (
        <button onClick={handleGoogleSignIn} className={"w-full flex items-center justify-center space-x-2 bg-indigo-500 text-white max-w-md p-4 rounded-lg font-medium font-Poppins transition hover:shadow-lg hover:bg-indigo-600"}>
            <BsGoogle />
            <div>Continue with Google</div>
        </button>
    );
};

export default SignIn;